import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ThumbsUpFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 19.5546H3V11.7479H6V19.5546ZM2.99999 21.5546H5.99999C7.10456 21.5546 8 20.6592 8 19.5546V11.7479C8 10.6433 7.10457 9.7479 6 9.7479H3C1.89543 9.7479 1 10.6433 1 11.7479V19.5546C1 20.6592 1.89542 21.5546 2.99999 21.5546Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.25 20.7499C6.25 21.1642 6.58579 21.4999 7 21.4999H18.081C19.2496 21.4999 20.2906 20.7614 20.6766 19.6584L22.7766 13.6584C23.4024 11.8704 22.0754 9.99994 20.181 9.99994H15.6541L15.7907 9.69257C16.757 7.51844 16.2845 4.97375 14.6021 3.29141L14.5303 3.21961C14.2374 2.92672 13.7626 2.92672 13.4697 3.21961L6.46967 10.2196C6.32902 10.3603 6.25 10.551 6.25 10.7499V20.7499Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ThumbsUpFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ThumbsUpFilledIcon;
